/**
 * @module support/shared
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
import { Injectable } from '@angular/core';
import { GPC_CONSTS } from '@support/shared/constants/app.constants';
// Interfaces
import { DnsSettings } from '@support/api/proxies/requests/API_2240.interface';

@Injectable(
  { providedIn: 'root' }
)
export class AuthService {
  /**
   * Stores the string name value for oamCookieName
   */
  private oamCookieName: string;
  /**
   * Stores the value for oamCookie
   */
  private oamCookieValue: string;

  constructor() {}

  /**
   * Function to fetch the OAMAuthnCookie or oamToken from cookie
   * @returns {string} SSO Token
   */
  public getSSOToken(): string {
    let ssoToken = this.getCookie('oamToken');
    // tslint:disable-next-line:no-global-variables
    const cookies = document.cookie.split(';');
    const startSubstr = 0;
    const endSubstr = 14;
    const cookieLength = 16;
    const cookieCount = cookies.length;
    for (let i = 0; i <= cookieCount; i++) {
      if (
        cookies[i] &&
        cookies[i].length >= cookieLength &&
        cookies[i].trim().substr(startSubstr, endSubstr) === 'OAMAuthnCookie'
      ) {
        this.oamCookieName = cookies[i].split('=')[0];
        this.oamCookieValue = cookies[i].split('=')[1];
        ssoToken = this.oamCookieName + '=' + this.oamCookieValue;
        break;
      }
    }

    return ssoToken;
  }

  /**
   * Function to get the cookie value
   * @param cookieName Stores the name of the cookie
   * @returns string
   */
  private getCookie(cookieName: string): string {
    // tslint:disable-next-line:no-global-variables
    const match = document.cookie.match(new RegExp(`${cookieName}=([^;]+)`));
    if (match) {
      return match[1];
    }
  }

  /**
   * Function to get the cookie value
   * @param cookieName Stores the name of the cookie
   */
  public setCookie(cookieName: string, localDoNotSellSetting?: string): void {
    const isGpcEnabled = this.getGlobalPrivacyControl();
    const isGpcDNTSet = this.getPerGlobalPrivacyControlDoNotSellSet();
    if (isGpcDNTSet && isGpcEnabled && this.getCookie(GPC_CONSTS.COOKIE_NAME) !== '1') {
      const localDoNotSell =
        isGpcEnabled || localDoNotSellSetting === GPC_CONSTS.DO_NOT_SELL ? 1 : 0;
      const decadeForCookie = 10;
      const CookieDate = new Date();
      CookieDate.setFullYear(CookieDate.getFullYear() + decadeForCookie);
      document.cookie = `${cookieName}=${localDoNotSell};expires=${CookieDate.toUTCString()};domain=t-mobile.com`;
    }
  }

  /**
   * Function to get the cookie value
   * @param cookieName Stores the name of the cookie
   */
  public getDNS(): DnsSettings {
    const globalPrivacyControl = this.getGlobalPrivacyControl();
    return {
      globalPrivacyControlSignal:
        globalPrivacyControl === true
          ? GPC_CONSTS.YES
          : globalPrivacyControl === false
            ? GPC_CONSTS.NO
            : null,
      doNotSellSetting: this.getCookie('dnt'),
    };
  }

  public clearAllCookies(): void {
    const cookies = document.cookie.split(';');
    for (let i = 0; i < cookies.length; i++) {
      const cookieName = cookies[i].split('=');
      document.cookie = `${cookieName[0]}=;expires=Thu, 21 Sep 1979 00:00:01 UTC;domain=t-mobile.com`;
    }
  }

  private getGlobalPrivacyControl(): boolean {
    return window && window[GPC_CONSTS.NAVIGATOR] && window[GPC_CONSTS.NAVIGATOR][GPC_CONSTS.GPC];
  }

  private getPerGlobalPrivacyControlDoNotSellSet(): boolean {
    return window && window[GPC_CONSTS.GPC_VAR];
  }
}
